import iconFactory from './utils/iconFactory';

var FacebookIcon = iconFactory('facebook', {
  icon: 'M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z',
  mask: 'M0,0v64h64V0H0z M39.6,22l-2.8,0c-2.2,0-2.6,1.1-2.6,2.6V28h5.3l-0.7,5.3h-4.6V47h-5.5V33.3H24V28h4.6V24 c0-4.6,2.8-7,6.9-7c2,0,3.6,0.1,4.1,0.2V22z',
  color: '#3b5998'
});

export default FacebookIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-share/es/FacebookIcon.js
// module id = 1700
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 13 20 21